import React from "react";
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Chip from "@mui/material/Chip";
import PlayerAvatar from "../../components/ui/PlayerAvatar";
import TeamCrest from "../../components/ui/TeamCrest";
import TrofeusVitorias from "../../components/TrofeusVitorias";

const Player = ({ player, vitorias = 0 }) => (
  <Stack direction="row" spacing={1.5} alignItems="center" sx={{ flexGrow: 1, minWidth: 0 }}>
    <PlayerAvatar userId={player.guest ? null : player.user} name={player.user_name} size={36} />
    <Box sx={{ flexGrow: 1, minWidth: 0 }}>
      <Stack direction="row" spacing={0.75} alignItems="center" sx={{ minWidth: 0 }}>
        <Typography fontWeight={600} noWrap sx={{ minWidth: 0 }}>{player.user_name}</Typography>
        <TrofeusVitorias vitorias={vitorias} />
      </Stack>
      <Typography variant="caption" color="text.secondary">
        Chegada {player.posicaoOriginal ?? "-"}º · fila {player.posicaoFila ?? "-"}º · {player.jogos ?? 0} jogos
      </Typography>
    </Box>
    {player.team !== null && player.team !== undefined && (
      <Stack direction="row" spacing={0.75} alignItems="center">
        <TeamCrest name={player.team} size={26} />
        {player.pote && <Chip size="small" label={`Pote ${player.pote}`} variant="outlined" />}
      </Stack>
    )}
  </Stack>
);

export default Player;
